// extracted by mini-css-extract-plugin
export default {"wrapper":"SkeletonProfileInfo_wrapper__8slaX","content":"SkeletonProfileInfo_content__hpCCH","skeletonItem":"SkeletonProfileInfo_skeletonItem__aiCSY"};